import React, { ComponentProps, forwardRef, memo } from 'react'

import { Box } from '../uiKit/components/Box'

interface CardProps extends ComponentProps<typeof Box> {
  transparent?: boolean
}

export const Card = memo(
  forwardRef<HTMLDivElement | null, CardProps>(
    ({ transparent, ...rest }, ref) => (
      <Box
        {...{
          ref,
          bra: 'sm',
          py: 'abs.20',
          px: 'xl',
          bd: '1px solid',
          bc: transparent ? 'navy.10' : 'transparent',
          bgc: transparent ? 'inherit' : 'white.100',
          ...rest,
        }}
      />
    ),
  ),
)
